import { BusinessLoginState, BusinessLoginMutations, BusinessLoginActions, BusinessLoginOperation } from './types';
import firebaseService from '@/services/firebase';
import { Addon, AddonConverter, Business, BusinessConverter } from '@/composables/business/types';

export default function actionsFactory(state: BusinessLoginState, mutations: BusinessLoginMutations): BusinessLoginActions {

    function setBusinessLoginParams(businessId: string, language: string = "cs", operation: BusinessLoginOperation | null = null, addonId: string | null = null) {
        mutations.MUTATION_SET_BUSINESS_LOGIN(businessId, language, operation, addonId);
    }

    function clearBusinessLoginParams() {
        mutations.MUTATION_CLEAR_BUSINESS_LOGIN();
    }

    async function loginAsBusiness(businessId: string, language: string = "cs") {
        try {
            const result = await firebaseService.business("getAdminLoginUrl", {
                businessId,
                language,
            });
            window.location.href = result.link;
        } catch (error) {
            console.error("Business login failed:", error);
            throw error;
        }
    }

    async function executeBusinessLogin() {
        if (state.businessId) {
            try {
                console.log('executeBusinessLogin', state);
                mutations.MUTATION_SET_LOADING(true);
                mutations.MUTATION_SET_ERROR(null);
                const operation: BusinessLoginOperation = state.operation || "console-login";

                if (operation === "console-login") {
                    await loginAsBusiness(
                        state.businessId,
                        state.language || "cs"
                    );
                } else if (operation === "open-stripe" || operation === "open-fakturoid") {
                   
                    // load business using converter
                    const business: Business = await firebaseService.getBusiness(state.businessId);
                    if (!business) {
                        throw new Error("Business not found");
                    }
                    if (operation === "open-stripe") {
                        const customerId = business?.billing?.stripe?.customerId;
                        if (!customerId) throw new Error("Stripe customerId not found");
                        window.location.href = `https://dashboard.stripe.com/customers/${customerId}`;
                    } else {
                        const subjectId = business?.billing?.fakturoid?.subjectId;
                        if (!subjectId) throw new Error("Fakturoid subjectId not found");
                        window.location.href = `https://app.fakturoid.cz/galandrcommunication1/subjects/${subjectId}`;
                    }
                } else if (operation === "open-addon-db") {
                    if (!state.addonId) throw new Error("addonId is required");
                    window.location.href = `https://console.firebase.google.com/u/0/project/mehub-cz/firestore/data/~2Faddons~2F${state.addonId}`;
                } else if (operation === "open-business-db") {
                    window.location.href = `https://console.firebase.google.com/u/0/project/mehub-cz/firestore/data/~2Fbusinesses~2F${state.businessId}`;
                } else if (operation === "show-addon") {
                    if (!state.businessId) throw new Error("businessId is required");
                    const router = (window as any).app?.$router || null;
                    if (router) {
                        router.push({ name: 'businesses', query: { search: state.businessId } });
                    } else {
                        window.location.href = `/businesses?search=${encodeURIComponent(state.businessId)}`;
                    }
                }

                setTimeout(() => {
                    mutations.MUTATION_CLEAR_BUSINESS_LOGIN();
                }, 1000);
            } catch (error: any) {
                mutations.MUTATION_SET_ERROR(error.message || "Business login failed");
                throw error;
            }
        }
    }

    return {
        setBusinessLoginParams,
        clearBusinessLoginParams,
        executeBusinessLogin
    };
}
